import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import RaffleAvatar from "./RaffleAvatar";
import { default as FilledCircledTick } from "/public/assets/filled-circled-tick.svg?react";
import { default as FilledCircledX } from "/public/assets/filled-circled-x.svg?react";

type Props = {
  isParticipating: boolean;
  avatarUrl: string | null;
};

export default function RaffleParticipationStatusCard(props: Props) {
  return (
    <Root>
      <RaffleAvatar src={props.avatarUrl} />
      <Container>
        {props.isParticipating ? (
          <>
            <RaffleStatus>
              <FilledCircledTick />
              <span>{translate(STRINGS.YOURE_IN_THE_RAFFLE)}</span>
            </RaffleStatus>
          </>
        ) : (
          <>
            <RaffleStatus>
              <FilledCircledX />
              <span>{translate(STRINGS.YOURE_NOT_IN_THE_RAFFLE)}</span>
            </RaffleStatus>
          </>
        )}
      </Container>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const RaffleStatus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 18px;
  color: var(--tw-gray-800);
`;

const Container = styled.div`
  flex-direction: column;
  background: rgba(255, 255, 255, 0.7);
  padding: 18px 32px;
  border-radius: 100px;
  position: relative;
  text-align: center;
`;
